<template>
  <van-popup 
    v-model="visible" 
    position="bottom"
    get-container="body"
    :style="{ width: '100%',height: '100%' }">
    <van-nav-bar @click-left="visible = false" class="navbar">
      <van-icon name="cross" size="20" slot="left" />
      <van-tabs v-model="activeTab" slot="title" color="#1989fa" @change="tabChange">
        <van-tab :title="elecsealText" name="elecseal" v-if="elecseal"></van-tab>
        <van-tab :title="esignatureText" name="esignature" v-if="esignature"></van-tab>
      </van-tabs>
    </van-nav-bar>
    <div class="tabs-content">
      <div class="tab-panel" v-if="elecseal" v-show="activeTab === 'elecseal'" :class="{'seal-empty': signatureType != '2' && !seals.length}">
        <div class="elecseal-wrapper" ref="elecsealWrapper">
          <template v-if="signatureType != '2'">
            <div class="seal-box" v-for="(item, index) in seals" :key="index" @click="sealsChange(item)">
              <div class="seal" :class="{'seal-selected': sealChecked.indexOf(item.WID) > -1 }">
                <van-icon 
                  :name="sealChecked.indexOf(item.WID)> -1 ? 'success' : 'circle'" 
                  class="seal-icon"
                  :class="{'seal-icon-checked': sealChecked.indexOf(item.WID)> -1, 'seal-icon-disabled': sealChecked.indexOf(item.WID) == -1 && isMultiple}"
                  size="20px" 
                  color="#dddee1"/>
                <img :src="item.url">
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="tab-panel" v-if="esignature" v-show="activeTab === 'esignature'">
        <div class="esignatrue-box" :class="{'esignature-canvas-empty': !esignatureBegin}"  v-show="!esignatureEdit">
          <canvas ref="canvas"></canvas>
        </div>
        <div class="esignatrue-img" v-show="esignatureEdit">
          <img :src="esignatureData" ref="showImg">
        </div>
      </div>
      <van-button type="info" block v-if="elecseal && activeTab === 'elecseal'" @click="useSeals" :disabled="btnDisabled">{{confirmText}}</van-button>
      <van-row class="form-add-actions" v-if="esignature && activeTab === 'esignature' && !esignatureEdit" >
        <van-col span="12">
          <van-button block @click="clearCanvas">{{clearText}}</van-button>
        </van-col>
        <van-col span="12">
          <van-button block type="info" @click="canvasConfirm">{{confirmText}}</van-button>
        </van-col>
      </van-row>
      <van-row class="form-add-actions" v-if="esignature && activeTab === 'esignature' && esignatureEdit" >
        <van-col span="12">
          <van-button block @click="editCanvas">{{editText}}</van-button>
        </van-col>
        <van-col span="12">
          <van-button block type="info" @click="useCanvas" :disabled="(multiple && sealChecked.length == 2) || (!multiple && sealChecked.length == 1)">{{useText}}</van-button>
        </van-col>
      </van-row>
    </div>
  </van-popup>
</template>
<script>
  import SignaturePad from "utils/signature"
  import api from '@/api/comment'
  import { getContextPath } from 'utils'
  const ContextPath = getContextPath();

  export default {
    name: "seal-modal",
    data() {
      return {
        elecsealText: '印章',
        esignatureText: '签名',
        confirmText: '确定',
        clearText: '清空',
        editText: '编辑签名',
        useText: '使用签名',
        visible: false,
        activeTab: "elecseal",
        signaturePad: null,
        canvas: null,
        esignatureEdit: false,
        esignatureData: null,
        seals: [],
        loadSeal: ContextPath + "/sys/emapflow/elecseal/loadSeal.do",
        sealChecked: [],
        signWid: '',
        esignatureBegin: false
      }
    },
    props: {
      value: Boolean,
      loading: Boolean,
      elecseal: Boolean,
      esignature: Boolean,
      signatureType: [String, Number],
      chapterWID: String,
      clip: Boolean,
      multiple: Boolean,
      needElecseal: Boolean,
      needEsignature: Boolean,
    },
    watch: {
      value(val) {
        this.visible = val;
        if(val) {
          if(this.seals.length) {
            let wids = this.chapterWID.split(',');
            if(wids.length) {
              let sealWids = this.seals.map(seal => seal.WID);
              this.signWid = wids.filter(wid => sealWids.indexOf(wid) == -1)[0] || '';
              if(this.signWid || this.esignatureData) {
                this.esignatureEdit = true;
              }
            } else {
              this.initCanvas();
            }
          } else {
            this.getSeals();
          }
        }
      },
      visible(value) {
        this.$emit('input', value);
      },
      chapterWID(value) {
        this.sealChecked = [];
        if(value) {
          this.sealChecked = [];
          this.seals.forEach(seal => {
            if(value.indexOf(seal.WID) > -1) {
              this.sealChecked.push(seal.WID)
            }
          });
        }
      }
    },
    computed: {
      btnDisabled() {
        return this.signatureType == '1' ? !this.sealChecked.length : false 
      },
      isMultiple() {
        // 印章 -- 单选、多选判断
        if(this.multiple) {
          return this.sealChecked.length == (this.signWid || (this.esignature && this.elecseal && this.needElecseal && this.needEsignature) ? 1 : 2)
        } else {
          return this.signWid || this.sealChecked.length == 1
        }
      },
    },
    methods: {
      tabChange(name) {
        if(name === 'esignature') {
          this.esignatureEdit = !!this.esignatureData;
          if(this.esignatureData) {
            this.esignatureEdit = true;
          } else {
            this.esignatureEdit = false;
            this.initCanvas();
          }
        }
      },
      sealsChange(item) {
        if(this.sealChecked.indexOf(item.WID) == -1) {
          if(this.multiple && (this.sealChecked.length == 2 || (this.signWid && this.sealChecked.length == 1) || (this.sealChecked.length == 1 && this.needElecseal))) return
          if(!this.multiple && this.sealChecked.length == 1 ) return
        }
        if(this.sealChecked.indexOf(item.WID) > -1) {
          this.sealChecked = this.sealChecked.filter(seal => seal != item.WID);
        } else {
          this.sealChecked.push(item.WID);
        }
      },
      useSeals() {
        let wids = [], urls = [];
        if(this.signWid) {
          wids = [this.signWid, this.sealChecked[0]];
          urls = [this.loadSeal + "?wid=" + this.signWid + "&_=" + new Date().getTime(), this.loadSeal + "?wid=" + this.sealChecked[0]];
        } else {
          wids = JSON.parse(JSON.stringify(this.sealChecked));
          urls = this.sealChecked.map(item => this.loadSeal + "?wid=" + item);
        }
        this.$emit('on-confirm', wids, urls);
      },
      initCanvas() {
        const _this = this;
        this.$nextTick(function(){
          let ratio =  Math.max(window.devicePixelRatio || 1, 1);
          this.canvas = this.$refs.canvas;
          this.canvas.width = this.canvas.offsetWidth * ratio;
          this.canvas.height = this.canvas.offsetHeight * ratio;
          this.canvas.getContext("2d").scale(ratio, ratio);
          this.signaturePad = new SignaturePad(this.canvas, {
            penColor: 'rgb(0,0,0)',
            backgroundColor: 'rgb(255,255,255)',
            onBegin: function() {
              _this.esignatureBegin = true;
            }
          });
          this.signaturePad.clear();
          this.esignatureBegin = false;
        })
      },
      clearCanvas() {
        this.signaturePad.clear();
        this.esignatureBegin = false;
      },
      canvasConfirm() {
        if(this.signaturePad.isEmpty()) {
          this.$toast('签名不能为空')
        } else {
          this.esignatureData = this.signaturePad.toDataURL();
          this.esignatureEdit = true;
          this.signaturePad.clear();
          this.esignatureBegin = false;
        }
      },
      editCanvas() {
        this.esignatureEdit = false;
        this.initCanvas();
      },
      useCanvas() {
        let wids = [], urls = [], base64;
        if(this.sealChecked.length) {
          wids = [this.sealChecked[0]];
          urls = [this.loadSeal + "?wid=" + this.sealChecked[0]];
        }
        if(this.esignatureData.indexOf("data:image/png;base64") !== 0) {
          wids.push(this.esignatureData.match(/wid=(\S*)&/)[1]);
          urls.push(this.esignatureData);
        } else {
          if(this.clip) {
            base64 = this.clipCanvas()
          } else {
            base64 = this.esignatureData;
          }
        }
        this.$emit('on-confirm', wids, urls, base64);
      },
      getSeals() {
        this.seals = [];
        this.sealChecked = [];
        api.getSeals().then(data => {
          if(data.code == '0'){
            let rows = data.datas.queryMySeals.rows;
            rows.forEach((row) => {
              if(row.STYPE === "0") {
                if(this.chapterWID.indexOf(row.WID) > -1) {
                  this.sealChecked.push(row.WID);
                }
                row.url = this.loadSeal + "?wid=" + row.WID;
                this.seals.push(row);
              } else {
                this.esignatureEdit = true;
                if(this.chapterWID.indexOf(row.WID)>-1) {
                  this.signWid = row.WID;
                }
                this.esignatureData = this.loadSeal + '?wid=' + row.WID + "&_=" + new Date().getTime();
              }
            });
            if(!this.esignatureEdit) this.initCanvas();
          }else {
            this.$Message.error(data.msg);
          }
        })
      },
      resizeCanvas() {
        if(!this.esignatureEdit && this.canvas) {
          let ratio =  Math.max(window.devicePixelRatio || 1, 1);
          this.canvas.width = this.canvas.offsetWidth * ratio;
          this.canvas.height = this.canvas.offsetHeight * ratio;
          this.canvas.getContext("2d").scale(ratio, ratio);
          this.signaturePad.clear();
          this.esignatureBegin = false;
        }
      },
      clipCanvas() {
        let img = this.$refs.showImg;
        var c = document.createElement("canvas");
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;
        var ctx= c.getContext("2d");
        ctx.drawImage(img,0,0);
        var imgData = ctx.getImageData(0, 0, c.width, c.height).data;
        var lOffset = c.width, rOffset = 0,tOffset = c.height, bOffset = 0;
        for (var i = 0; i < c.width; i++) {
          for (var j = 0; j < c.height; j++) {
            var pos = (i + c.width * j) * 4;
            if ((imgData[pos] < 255 && imgData[pos] > 0) || 
              (imgData[pos + 1] < 255  && imgData[pos+1] > 0) || 
              (imgData[pos + 2] < 255  && imgData[pos+2] > 0) || 
              (imgData[pos + 3] < 255  && imgData[pos+3] > 0)) {
              bOffset = Math.max(j, bOffset); // 找到有色彩的最下端
              rOffset = Math.max(i, rOffset); // 找到有色彩的最右端

              tOffset = Math.min(j, tOffset); // 找到有色彩的最上端
              lOffset = Math.min(i, lOffset); // 找到有色彩的最左端
            }
          }
        }
        lOffset++;
        rOffset++;
        tOffset++;
        bOffset++;

        var c2 = document.createElement("canvas");
        c2.width = rOffset - lOffset;
        c2.height = bOffset - tOffset;
        var ctx2= c2.getContext("2d");
        ctx2.drawImage(img,lOffset,tOffset,c2.width,c2.height,0,0,c2.width, c2.height);
        return c2.toDataURL();
      }
    },
    mounted() {
      // 移动设备转屏
      window.onresize = this.resizeCanvas;
    }
  };
</script>
<style scoped>
  .navbar .van-nav-bar__title {
    max-width: 50%;
  }
  .navbar >>> .van-hairline--top-bottom::after {
    border-width: 0;
  }
  .tabs-content {
    height: calc(100% - 46px);
  }
  .tab-panel {
    height: calc(100% - 44px);
    overflow: auto;
    padding: 10px 15px;
  }
  .seal-empty::after {
    content: "无印章数据";
    color: #969799;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
  .seal-box {
    float: left;
    width: 33.33%;
    margin: 5px 0;
  }
  .seal {
    position: relative;
    height: 100px;
    width: 100px;
    border: 1px solid #dddee1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
  .seal img {
    display: block;
    max-height: 100%;
    max-width: 100%;
  }
  .seal-icon {
    position: absolute;
    top: 2px; 
    right: 2px;
    z-index: 3;
  }
  .seal-icon-checked {
    color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
    border-radius: 100%;
  }
  .seal-icon-disabled {
    background: #dddee1;
    border-radius: 50%;
  }
  .seal-selected::after {
    display: block;
    content: '';
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    position: absolute;
    z-index: 2;
  }
  .esignatrue-box {
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid #dddee1;
    box-shadow: 0 1px 4px rgba(0, 0, 0, .27), 0 0 40px rgba(0, 0, 0, .08) inset;
  }
  .esignature-canvas-empty:after {
    content: "请在画板区域用手写下签名";
    color: #969799;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
  canvas {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;
  }
  .esignatrue-img {
    display: flex;
    height: 100%;
    width: 100%;
  }
  .esignatrue-img img {
    display: block;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }
</style>